import warningIcon from '../../../../assets/icons/warning.png';
import infoIcon from '../../../../assets/icons/info.png';
import odometroIcon from '../../../../assets/icons/odometro.png';
import taxiIcon from '../../../../assets/icons/taxi.png';
import bussIcon from '../../../../assets/icons/buss.png';
import notaIcon from '../../../../assets/icons/nota.png';
import unidadAliadoIcon from '../../../../assets/icons/unidadAliado.png';
import reload from '../../../../assets/icons/reload.png';
import proibido from '../../../../assets/icons/proibido.png';
import mapaIcon from '../../../../assets/icons/mapa.png';
import palomitaIcon from '../../../../assets/icons/palomita.png';
import circuloIcon from '../../../../assets/icons/circulo.png';
import calendarioCanceladoIcon from '../../../../assets/icons/calendarioCancelado.png';
import React from 'react';

/* ─── Configuración de cards de incidencias ──────────────────────────────── */
const CARDS = [
    {
        key: 'operador',
        titulo: 'Incidencias del Operador',
        icono: warningIcon,
        color: '#f26202',
        columnas: [
            { field: 'ID', header: 'ID' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'TIPO_DESCRIPCION', header: 'Tipo' },
        ],
    },
    {
        key: 'generales',
        titulo: 'Incidencias Generales',
        icono: infoIcon,
        color: '#0284d4',
        columnas: [
            { field: 'ID', header: 'ID' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'ID_UNIDAD', header: 'Unidad' },
            { field: 'NOMBRE_CHOFER', header: 'Operador' },
            { field: 'USUARIO', header: 'Usuario' },
            { field: 'DETALLE', header: 'Detalle' },
            { field: 'CAUSA', header: 'Causa' },
            { field: 'EFECTO', header: 'Efecto' },
        ],
    },
    {
        key: 'excesos_velocidad',
        titulo: 'Excesos de Velocidad',
        icono: odometroIcon,
        color: '#DC2F02',
        conteoGrupos: [
            { label: 'Con Bitácora', cond: (r) => r.ID_BITACORA !== 'SIN SERVICIO' },
            { label: 'Sin Bitácora', cond: (r) => r.ID_BITACORA === 'SIN SERVICIO' },
        ],
        columnas: [
            { field: 'ID', header: 'ID' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'ASUNTO', header: 'Asunto' },
            { field: 'ID_UNIDAD', header: 'Unidad' },
            { field: 'NOMBRE_CHOFER', header: 'Operador' },

        ],
    },
    {
        key: 'taxis',
        titulo: 'Taxis',
        icono: taxiIcon,
        color: '#faa307',
        columnas: [
            { field: 'ID', header: 'ID' },
            { field: 'ID_BITACORA', header: 'ID Bitácora' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'CAUSA', header: 'Causa' },
            { field: 'EFECTO', header: 'Efecto' },
            { field: 'DETALLE', header: 'Detalle' },
            { field: 'MONTO_TAXI', header: 'Monto Taxi' },
        ],
    },
    {
        key: 'unidades_incorrectas',
        titulo: 'Unidades Incorrectas',
        icono: bussIcon,
        color: '#6C757D',
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'ID_UNIDAD', header: 'Unidad' },
            { field: 'TIPO_UNIDAD_REAL', header: 'Unidad utilizada' },
            { field: 'TIPO_UNIDAD_ESPERADO', header: 'Unidad contratada' },
        ],
    },
    {
        key: 'excepciones',
        titulo: 'Excepciones',
        icono: notaIcon,
        color: '#495057',
        conteoGrupos: [
            { label: 'A', cond: (r) => r.ZONA == 1 },
            { label: 'B', cond: (r) => r.ZONA == 2 },
            { label: 'C', cond: (r) => r.ZONA == 3 },
        ],
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'COMENTARIOS', header: 'Comentarios' },
           
            {
                field: 'EXCEPCION_CTE',
                header: 'Requerido por el cliente',
                body: (row) => {
                    const val = row.EXCEPCION_CTE;
                    if (val === null || val === undefined)
                        return <span className="dashBadge dashBadge--neutral">Sin dato</span>;
                    return val
                        ? <span className="dashBadge dashBadge--success">Sí</span>
                        : <span className="dashBadge dashBadge--danger">No</span>;
                },
            },
            { field: 'NOMBRE_ZONA', header: 'Zona' },
        ],
    },
    {
        key: 'rutas_efectividad50',
        titulo: 'Efectividad de Rutas ≤ 50%',
        icono: unidadAliadoIcon,
        color: '#6f42c1',
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'EFECTIVIDAD_RUTA', header: 'Efectividad' },
            { field: 'OPERADOR', header: 'Operador' },
            { field: 'ID_UNIDAD', header: 'Unidad' },
            { field: 'ESTATUS', header: 'Estatus' },
            
        ],
    },
    {
        key: 'todos_los_servicios',
        titulo: 'Servicios Ejecutados',
        icono: unidadAliadoIcon,
        color: '#6f42c1',
        conteoGrupos: [
            { label: 'Suma', cond: (r) => r.PROVEEDOR_SERVICIO == 1 },
            { label: 'Proveedor', cond: (r) => r.PROVEEDOR_SERVICIO != 1 },
        ],
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            {
                field: 'TIPO_SERVICIO',
                header: 'Tipo',
            },
            { field: 'NOMBRE_PROVEEDOR', header: 'Proveedor' },
        ],
    },
        {
            key: 'transferencias',
            titulo: 'transferencias',
            icono: reload,
            color: '#6f42c1',
            conteoGrupos: [
                { label: 'Atrasadas', cond: (r) => r.ATRASADA == 'SI' },
                { label: 'Total', cond: (r) => r.ATRASADA == 'SI' || r.ATRASADA == 'NO' },
            ],
            columnas: [
                { field: 'ID_BITACORA', header: 'Bitácora' },
                { field: 'FECHA_TRANSFERENCIA', header: 'Fecha de transferencia' },
                { field: 'HORA_INICIO_RUTA', header: 'Fecha de ejecución' },
                { field: 'COMENTARIO', header: 'Comentario' },
                { field: 'OPERADOR_ORIGEN', header: 'Operador Origen' },
                { field: 'OPERADOR_DESTINO', header: 'Operador Destino' },
                { field: 'RUTA', header: 'Ruta' },
                { field: 'USUARIO', header: 'Usuario' },
                { field: 'ATRASADA', header: 'Atrasada' },
                
                { field: 'DIFERENCIA_MINUTOS', header: 'Diferencia (minutos)' },
            ],
        },
    
    {
        key: 'efectividad_turno',
        titulo: 'Efectividad del Turno',
        icono: palomitaIcon,
        color: '#16a34a',
        getData: (s) => s.incidencias.todos_los_servicios ?? [],
        conteoGrupos: [
            {
                label: 'Promedio',
                cond: () => true,
                calc: (arr) =>
                    arr.length
                        ? `${(arr.reduce((s, r) => s + (Number(r.EFECTIVIDAD_RUTA) || 0), 0) / arr.length).toFixed(1)}%`
                        : '—',
            },
            {
                label: '≥ 80%',
                cond: (r) => Number(r.EFECTIVIDAD_RUTA) >= 80,
            },
            {
                label: '< 80%',
                cond: (r) => r.EFECTIVIDAD_RUTA !== null && r.EFECTIVIDAD_RUTA !== undefined && Number(r.EFECTIVIDAD_RUTA) < 80,
            },
        ],
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'CLIENTE', header: 'Cliente' },
            { field: 'HORA_ARRANQUE', header: 'Hora Arranque' },
            { field: 'HORA_LLEGADA', header: 'Hora Llegada' },
            { field: 'OPERADOR', header: 'Operador' },
            { field: 'ID_UNIDAD', header: 'Unidad' },
            { field: 'TIPO_SERVICIO', header: 'Tipo' },
            { field: 'ESTATUS', header: 'Estatus' },
            { field: 'EFECTIVIDAD_RUTA', header: 'Efectividad' },
        ],
    },
    {
        key: 'calificacion_turno',
        titulo: 'Calificación del Turno',
        icono: circuloIcon,
        color: '#0369a1',
        getData: (s) => s.incidencias.todos_los_servicios ?? [],
        conteoGrupos: [
            {
                label: 'Promedio',
                cond: () => true,
                calc: (arr) => {
                    const conDato = arr.filter((r) => r.CALIFICACION !== null && r.CALIFICACION !== undefined);
                    return conDato.length
                        ? (conDato.reduce((s, r) => s + (Number(r.CALIFICACION) || 0), 0) / conDato.length).toFixed(1)
                        : '—';
                },
            },
            {
                label: 'Con calif.',
                cond: (r) => r.CALIFICACION !== null && r.CALIFICACION !== undefined,
            },
            {
                label: 'Sin calif.',
                cond: (r) => r.CALIFICACION === null || r.CALIFICACION === undefined,
            },
        ],
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'CLIENTE', header: 'Cliente' },
            { field: 'HORA_ARRANQUE', header: 'Hora Arranque' },
            { field: 'HORA_LLEGADA', header: 'Hora Llegada' },
            { field: 'OPERADOR', header: 'Operador' },
            { field: 'ID_UNIDAD', header: 'Unidad' },
            { field: 'TIPO_SERVICIO', header: 'Tipo' },
            { field: 'ESTATUS', header: 'Estatus' },
            { field: 'CALIFICACION', header: 'Calificación' },
        ],
    },
    
    {
        key: 'servicios_con_conflicto',
        titulo: 'Operadores con Conflictos de Programación',
        icono: proibido,
        color: '#e63946',
        columnas: [
            { field: 'NOMBRE_OPERADOR', header: 'Operador', style: { minWidth: '160px' } },
            { field: 'TOTAL_BITACORAS', header: 'Total', style: { width: '70px' } },
            {
                field: 'BITACORAS',
                header: 'Bitácoras con conflicto',
                style: { minWidth: '460px' },
                body: (row) => {
                    const bitacoras = row.BITACORAS ?? [];

                    /* ── Convierte HH:MM, HH:MM:SS o "YYYY-MM-DD HH:MM:SS" a minutos ── */
                    const toMin = (t) => {
                        if (!t) return null;
                        const parte = String(t).includes(' ') ? String(t).split(' ')[1] : String(t);
                        const [h, m] = parte.split(':').map(Number);
                        if (isNaN(h) || isNaN(m)) return null;
                        return h * 60 + m;
                    };

                    /* ── Detecta si dos bitácoras se enciman en tiempo ── */
                    const seEnciman = (a, b) => {
                        let sa = toMin(a.HORA_INICIO), ea = toMin(a.HORA_FIN);
                        let sb = toMin(b.HORA_INICIO), eb = toMin(b.HORA_FIN);
                        if (sa === null || ea === null || sb === null || eb === null) return false;
                        if (ea <= sa) ea += 1440; // cruza medianoche
                        if (eb <= sb) eb += 1440;
                        return sa < eb && sb < ea;
                    };

                    /* ── Union-Find para agrupar componentes conectados ── */
                    const n = bitacoras.length;
                    const parent = Array.from({ length: n }, (_, i) => i);
                    const find = (i) => parent[i] === i ? i : (parent[i] = find(parent[i]));
                    const union = (i, j) => { parent[find(i)] = find(j); };

                    for (let i = 0; i < n; i++)
                        for (let j = i + 1; j < n; j++)
                            if (seEnciman(bitacoras[i], bitacoras[j])) union(i, j);

                    /* ── Armar grupos: root → [índices] ── */
                    const grupos = {};
                    for (let i = 0; i < n; i++) {
                        const r = find(i);
                        if (!grupos[r]) grupos[r] = [];
                        grupos[r].push(i);
                    }

                    const COLORES_GRUPO = ['#fff0f0', '#fff8e1', '#f3e8ff', '#e8f4fd', '#e8fff0'];
                    let colorIdx = 0;
                    const colorGrupo = {};
                    Object.entries(grupos).forEach(([r, miembros]) => {
                        if (miembros.length > 1) colorGrupo[r] = COLORES_GRUPO[colorIdx++ % COLORES_GRUPO.length];
                    });

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {Object.entries(grupos).map(([root, miembros]) => {
                                const esConflicto = miembros.length > 1;
                                const filas = miembros.map((idx) => {
                                    const b = bitacoras[idx];
                                    return (
                                        <span key={b.ID_BITACORA} style={{ fontSize: '0.78rem', lineHeight: 1.6, display: 'block' }}>
                                            <strong>#{b.ID_BITACORA}</strong>&nbsp;
                                            {b.RUTA}&nbsp;&middot;&nbsp;
                                            {b.HORA_INICIO}&ndash;{b.HORA_FIN}&nbsp;&middot;&nbsp;
                                            <em>{b.ESTATUS}</em>
                                        </span>
                                    );
                                });

                                if (esConflicto) {
                                    return (
                                        <div key={root} style={{
                                            background: colorGrupo[root],
                                            border: '1.5px solid #e63946',
                                            borderRadius: '7px',
                                            padding: '8px 10px 6px',
                                            position: 'relative',
                                        }}>
                                            <span style={{
                                                position: 'absolute',
                                                top: '-9px',
                                                left: '10px',
                                                background: '#e63946',
                                                color: '#fff',
                                                fontSize: '0.6rem',
                                                fontWeight: 700,
                                                padding: '2px 8px',
                                                borderRadius: '4px',
                                                letterSpacing: '0.05em',
                                                textTransform: 'uppercase',
                                                whiteSpace: 'nowrap',
                                            }}>
                                                ⚠ Se enciman ({miembros.length})
                                            </span>
                                            {filas}
                                        </div>
                                    );
                                }

                                return <div key={root}>{filas}</div>;
                            })}
                        </div>
                    );
                },
            },
        ],
    },
    {
        key: 'todos_los_servicios',
        titulo: 'Servicios del Turno',
        icono: mapaIcon,
        color: '#0f766e',
        conteoGrupos: [
            { label: 'Empresarial', cond: (r) => r.TIPO === 'EMPRESARIAL' },
            { label: 'Administrativo', cond: (r) => r.TIPO === 'ADMINISTRATIVO' },
            { label: 'Especial', cond: (r) => r.TIPO === 'ESPECIAL' },
            { label: 'Taller', cond: (r) => r.TIPO === 'TALLER' },
        ],
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'HORA_ARRANQUE', header: 'Hora Arranque' },
            { field: 'HORA_LLEGADA', header: 'Hora Llegada' },
            { field: 'HORA_INICIO_RUTA', header: 'Hora Inicio' },
            { field: 'HORA_FIN_REAL', header: 'Hora Fin' },
            { field: 'CLIENTE', header: 'Cliente' },
            { field: 'NOMBRE_CHOFER', header: 'Operador' },
            { field: 'ID_UNIDAD', header: 'Unidad' },
            { field: 'HORA_INICIO', header: 'Inicio' },
            { field: 'HORA_FIN', header: 'Fin' },
            { field: 'ESTATUS', header: 'Estatus' },
            { field: 'TIPO', header: 'Tipo' },
        ],
    },
    {
        key: 'no_ejecutadas_canceladas',
        titulo: 'Servicios Cancelados',
        icono: calendarioCanceladoIcon,
        color: '#dc2626',
        columnas: [
            { field: 'ID_BITACORA', header: 'Bitácora' },
            { field: 'FECHA', header: 'Fecha' },
            { field: 'NOMBRE_CLIENTE', header: 'Cliente' },
            { field: 'NOMBRE_RUTA', header: 'Ruta' },
            { field: 'HORA_ARRANQUE', header: 'H. Arranque' },
            { field: 'HORA_LLEGADA', header: 'H. Llegada' },
            { field: 'MOTIVO', header: 'Motivo' },
            { field: 'OPERADOR', header: 'Operador' },
            { field: 'TIPO_SERVICIO', header: 'Tipo' },
        ],
    },
];

export default CARDS;
